/* istanbul ignore file */
import React from 'react';
import FiltersLayout from './ListFiltersLayout';
import useFiltersVisibilityHelper from '../useFiltersVisibilityHelper';
import { UiThemeOverrider } from 'framework/uiTheme';
import { FiltersLayoutProps } from '../types';
import DropDownFilterLayout from './filter/DropDownFilterLayout';
import DropDownFilterInputLayout from './filter/DropDownFilterInputLayout/DropDownFilterInputLayout';
import DateRangeFilterLayout from './filter/DateRangeFilterLayout';
import AutosuggestionDropdownLayout from './filter/AutosuggestionDropdownLayout';
import MultiSelectInputLayout from './filter/MultipleDropdownFilterInputLayout';
import MonthRangeFilterLayout from './filter/MonthRangeFilterLayout';
import SingleDateFilterLayout from './filter/SingleDateFilterLayout';

const ListFiltersLayout = ({ children, quickFilters, showAsIcon }: FiltersLayoutProps & { showAsIcon?: boolean }) => {
  const { isApplied, getFilteredChildren } = useFiltersVisibilityHelper({ children });

  return (
    <UiThemeOverrider
      overriddenLayouts={{
        DropdownLayout: DropDownFilterInputLayout,
        DropDownFilterLayout,
        DateRangeFilterLayout,
        SingleDateFilterLayout,
        AutosuggestionDropdownLayout,
        MultiSelectInputLayout,
        MonthRangeFilterLayout,
      }}
    >
      <FiltersLayout isApplied={isApplied} quickFilters={quickFilters} showAsIcon={showAsIcon}>
        {getFilteredChildren()}
      </FiltersLayout>
    </UiThemeOverrider>
  );
};

export default ListFiltersLayout;
